import { useQuery, useQueryClient } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { categoriesApi, CategoryTreeApi } from "./categoriesApi";

export const useCategoryTree = () => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.CATEGORY_TREE,
    queryFn: () => categoriesApi.fetchTree(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.CATEGORY_TREE,
    });
  };

  return { invalidate, isLoading, isFetching, tree: data?.data ?? [] };
};

export interface FlattenedCategory {
  id: number;
  name: string;
  friendlyName: string;
  slug: string;
  description: string;
  parentId: number | null;
  sortOrder: number;
  depth: number;
  parentName: string | null;
}

export const flattenTree = (
  tree: CategoryTreeApi[],
  depth = 0,
  parentName: string | null = null,
): FlattenedCategory[] => {
  const result: FlattenedCategory[] = [];
  for (const node of tree) {
    result.push({
      id: node.id,
      name: node.name,
      friendlyName: node.friendlyName,
      slug: node.slug,
      description: node.description,
      parentId: node.parentId,
      sortOrder: node.sortOrder,
      depth,
      parentName,
    });
    if (node.children?.length) {
      result.push(...flattenTree(node.children, depth + 1, node.name));
    }
  }
  return result;
};
